define( function() {
	"use strict";

	return ( /^(?:checkbox|radio)$/i );
} );



/*****************
 ** WEBPACK FOOTER
 ** ./~/jquery/src/manipulation/var/rcheckableType.js
 ** module id = 303
 ** module chunks = 0
 **/